export function toFiniteNumber(value: unknown, fallback = 0): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : fallback;
  }

  if (typeof value === 'string') {
    const directValue = Number(value.trim());
    if (Number.isFinite(directValue)) return directValue;

    const numericMatch = value.replace(/,/g, '').match(/-?\d+(?:\.\d+)?/);
    if (numericMatch) {
      const matchedValue = Number(numericMatch[0]);
      if (Number.isFinite(matchedValue)) return matchedValue;
    }
  }

  return fallback;
}

export function roundToTenth(value: unknown): number {
  const numericValue = toFiniteNumber(value);
  return Math.round((numericValue + Number.EPSILON) * 10) / 10;
}

export function formatRoundedNumber(value: number, locale?: string): string {
  const rounded = roundToTenth(value);
  return rounded.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });
}

export function roundNumbersInText(value: string, locale?: string): string {
  return value.replace(/-?\d+(?:\.\d+)?/g, (match) => {
    const numericValue = Number(match);
    if (!Number.isFinite(numericValue) || !match.includes('.')) return match;
    return formatRoundedNumber(numericValue, locale);
  });
}

export function formatRoundedDisplayValue(value: unknown, locale?: string): string {
  if (typeof value === 'number') {
    return formatRoundedNumber(value, locale);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return value;

    const numericValue = Number(trimmed);
    if (Number.isFinite(numericValue)) {
      return formatRoundedNumber(numericValue, locale);
    }

    return roundNumbersInText(value, locale);
  }

  return value == null ? '' : String(value);
}
